export const MARKETPLACE_OPERATOR_LEVEL_VALUES = [
  "intern",
  "professional",
  "manager",
  "director",
] as const;

export type MarketplaceOperatorLevelValue =
  (typeof MARKETPLACE_OPERATOR_LEVEL_VALUES)[number];

export const MARKETPLACE_OPERATOR_LEVEL_LABELS: Record<
  MarketplaceOperatorLevelValue,
  string
> = {
  intern: "Intern",
  professional: "Professional",
  manager: "Manager",
  director: "Director",
};

export function isMarketplaceOperatorLevel(
  value: string,
): value is MarketplaceOperatorLevelValue {
  return (MARKETPLACE_OPERATOR_LEVEL_VALUES as readonly string[]).includes(
    value,
  );
}

export function parseOperatorLevelsFromSearchParams(
  params: URLSearchParams,
): MarketplaceOperatorLevelValue[] {
  const seen = new Set<MarketplaceOperatorLevelValue>();
  const out: MarketplaceOperatorLevelValue[] = [];
  for (const raw of params.getAll("level")) {
    if (isMarketplaceOperatorLevel(raw) && !seen.has(raw)) {
      seen.add(raw);
      out.push(raw);
    }
  }
  return out;
}
